import styled from 'styled-components';

import { Link as BreweryLink } from '@xing-com/link';
import { xdlColorTextOnDark } from '@xing-com/tokens';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  align-items: center;
`;

const Link = styled(BreweryLink)`
  color: ${xdlColorTextOnDark};
  text-decoration: underline;
`;

export { Container, Link };
